(function () {
  'use strict';

  var config = window.__bundleStep1Config || {};
  var step2Url = config.step2Url || '/pages/build-your-bundle';

  var tierButtons = Array.prototype.slice.call(document.querySelectorAll('[data-bf1-tier]'));
  var stickyTotal = document.getElementById('bf1-stickybar-total');
  var stickyPerUnit = document.getElementById('bf1-stickybar-per-unit');
  var ctaBtn = document.getElementById('bf1-cta');
  var stickyCtaBtn = document.querySelector('[data-bf1-cta-sticky]');
  var ctaPricesEl = document.getElementById('bf1-cta-prices');
  var ctaCompareEl = document.getElementById('bf1-cta-compare');
  var ctaPriceEl = document.getElementById('bf1-cta-price');
  var stickyCtaPricesEl = document.getElementById('bf1-sticky-cta-prices');
  var stickyCtaCompareEl = document.getElementById('bf1-sticky-cta-compare');
  var stickyCtaPriceEl = document.getElementById('bf1-sticky-cta-price');

  var selectedQty = null;

  function selectTier(button) {
    tierButtons.forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-checked', 'false');
    });
    button.classList.add('is-active');
    button.setAttribute('aria-checked', 'true');

    selectedQty = button.dataset.qty;
    if (stickyTotal) stickyTotal.textContent = button.dataset.totalPrice || '';
    if (stickyPerUnit) stickyPerUnit.textContent = button.dataset.pricePerUnit || '';

    var totalPrice = button.dataset.totalPrice || '';
    var compareAt = button.dataset.compareAt || '';

    if (ctaCompareEl) ctaCompareEl.textContent = compareAt;
    if (ctaPriceEl) ctaPriceEl.textContent = totalPrice;
    if (ctaPricesEl) ctaPricesEl.hidden = !totalPrice;

    if (stickyCtaCompareEl) stickyCtaCompareEl.textContent = compareAt;
    if (stickyCtaPriceEl) stickyCtaPriceEl.textContent = totalPrice;
    if (stickyCtaPricesEl) stickyCtaPricesEl.hidden = !totalPrice;
  }

  tierButtons.forEach(function (btn) {
    btn.addEventListener('click', function () { selectTier(btn); });
  });

  var defaultTier = tierButtons.find(function (btn) { return btn.classList.contains('is-active'); }) || tierButtons[0];
  if (defaultTier) selectTier(defaultTier);

  function navigate() {
    if (!selectedQty) return;
    sessionStorage.setItem('bundleQty', selectedQty);
    window.location.href = step2Url + '?qty=' + encodeURIComponent(selectedQty);
  }

  if (ctaBtn) ctaBtn.addEventListener('click', navigate);
  if (stickyCtaBtn) stickyCtaBtn.addEventListener('click', navigate);

  /* ── Gallery ──────────────────────────────────────────────────────────────── */
  var galleryEl = document.querySelector('[data-bf1-gallery]');
  if (galleryEl) {
    var slides = Array.prototype.slice.call(galleryEl.querySelectorAll('.bf1-gallery__slide'));
    var thumbs = Array.prototype.slice.call(galleryEl.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = galleryEl.querySelector('[data-gallery-prev]');
    var nextBtn = galleryEl.querySelector('[data-gallery-next]');
    var currentSlide = 0;

    function goToSlide(n) {
      var prevEl = slides[currentSlide];
      prevEl.classList.remove('is-active');
      if (prevEl.tagName === 'VIDEO') prevEl.pause();
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.remove('is-active');

      currentSlide = (n + slides.length) % slides.length;

      var nextEl = slides[currentSlide];
      nextEl.classList.add('is-active');
      if (nextEl.tagName === 'VIDEO') nextEl.play().catch(function () {});
      if (thumbs[currentSlide]) thumbs[currentSlide].classList.add('is-active');
    }

    if (slides.length <= 1) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
    } else {
      if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentSlide - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentSlide + 1); });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToSlide(parseInt(thumb.dataset.galleryThumb, 10));
        });
      });
    }
  }

  /* ── Tabs ─────────────────────────────────────────────────────────────────── */
  var tabsEl = document.querySelector('[data-bf1-tabs]');
  if (tabsEl) {
    var tabBtns = Array.prototype.slice.call(tabsEl.querySelectorAll('[data-tab-btn]'));
    var tabPanels = Array.prototype.slice.call(tabsEl.querySelectorAll('[data-tab-panel]'));

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.tabBtn;

        tabBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(function (p) { p.classList.remove('is-active'); });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        var panel = tabsEl.querySelector('[data-tab-panel="' + idx + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  /* ── Tab 3 video — mute toggle ───────────────────────────────────────────── */
  var tab3Wraps = Array.prototype.slice.call(document.querySelectorAll('[data-bf1-tab3-video]'));
  tab3Wraps.forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var btn = wrap.querySelector('[data-bf1-unmute]');
    var label = btn && btn.querySelector('[data-unmute-label]');
    var icon = btn && btn.querySelector('.bf1-tab3-video__unmute-icon');
    if (!video || !btn) return;

    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (label) label.textContent = video.muted ? 'Tap to unmute' : 'Tap to mute';
      if (icon) {
        icon.innerHTML = video.muted
          ? '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/>'
          : '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>';
      }
    });
  });

  /* ── Sticky product nav ──────────────────────────────────────────────────── */
  var stickyNav = document.getElementById('bf1-sticky-nav');
  var productLayout = document.querySelector('.bf1-product-layout');

  if (stickyNav && productLayout) {
    var navObserver = new IntersectionObserver(function (entries) {
      var gone = !entries[0].isIntersecting;
      stickyNav.classList.toggle('is-visible', gone);
      stickyNav.setAttribute('aria-hidden', gone ? 'false' : 'true');
    }, { threshold: 0 });

    navObserver.observe(productLayout);

    var navCtaBtn = stickyNav.querySelector('[data-bf1-sticky-nav-cta]');
    if (navCtaBtn) navCtaBtn.addEventListener('click', navigate);
  }

  /* ── Countdown timer — 9-hour loop, resets automatically when it hits 0 ──── */
  function initLoopingCountdown() {
    var hrsEl = document.querySelector('[data-countdown-hrs]');
    var minEl = document.querySelector('[data-countdown-min]');
    var secEl = document.querySelector('[data-countdown-sec]');
    if (!hrsEl || !minEl || !secEl) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    var total = 9 * 60 * 60;
    var totalSeconds = total;

    function tick() {
      var hrs = Math.floor(totalSeconds / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      hrsEl.textContent = pad(hrs);
      minEl.textContent = pad(mins);
      secEl.textContent = pad(secs);

      totalSeconds--;
      if (totalSeconds < 0) totalSeconds = total;
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── Reserved-order timer — 10-minute loop, resets automatically when it hits 0 ── */
  function initReservedTimer() {
    var el = document.getElementById('bf1-reserved-timer');
    if (!el) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    var total = 10 * 60;
    var seconds = total;

    function tick() {
      var mins = Math.floor(seconds / 60);
      var secs = seconds % 60;
      el.textContent = pad(mins) + ':' + pad(secs);

      seconds--;
      if (seconds < 0) seconds = total;
    }

    tick();
    setInterval(tick, 1000);
  }

  initLoopingCountdown();
  initReservedTimer();
})();
